<template>
  <div class="page-container">
    <!--内容-->
    <div class="booksearchCon pt-200">
      <!--面包屑导航-->
      <Breadcrumb :breadcrumbList="['课件检索']"></Breadcrumb>
      <!--title-->
      <div class="resulttit mt-90 flex ai-center">
        <span class="ml-30 fs-20 color-fontcol4">高级查询</span>
      </div>
      <!--高级查询-->
      <div class="screencon flex ai-center mt-20">
        <span class="fs-18 color-fontcol3 ml-30">图书名称 :</span>
        <input class="ml-20" type="text" :value="bookname" @input="watchname" />
        <span class="fs-16 color-fontcol3 ml-100">作者 :</span>
        <input class="ml-20" type="text" :value="auctor" @input="watchactor" />
        <button class="btn-search bg-primary ml-50 color-white fs-16" @click="search">
          查询
        </button>
      </div>
      <!--搜索结果con-->
      <div class="bookcon pb-70">
        <div class="sort bg-colf5">
          <div class="con flex ai-center">
            <span class="fs-18 color-fontcol3">排序 :</span>
            <div class="model flex jc-center ai-center ml-20 point" @click="chosedate()">
              <span
                class="fs-18"
                :class="isdate == 1 || isdate == 2 ? 'color-primary' : 'color-fontcol3'"
                >时间排序</span
              >
              <img
                class="ml-5"
                src="../assets/image/topgray.png"
                v-if="isdate == 0 || isdate == 2"
                alt=""
              />
              <img class="ml-5" src="../assets/image/top.png" v-if="isdate == 1" alt="" />
              <img
                class="ml-5"
                v-if="isdate == 0 || isdate == 1"
                src="../assets/image/botgray.png"
                alt=""
              />
              <img class="ml-5" v-if="isdate == 2" src="../assets/image/bot.png" alt="" />
            </div>
            <div class="model flex jc-center ai-center ml-20 point" @click="choseprice()">
              <span
                class="fs-18"
                :class="isprice == 1 || isprice == 2 ? 'color-primary' : 'color-fontcol3'"
                >价格</span
              >
              <img
                class="ml-5"
                src="../assets/image/topgray.png"
                v-if="isprice == 0 || isprice == 2"
                alt=""
              />
              <img
                class="ml-5"
                src="../assets/image/top.png"
                v-if="isprice == 1"
                alt=""
              />
              <img
                class="ml-5"
                v-if="isprice == 0 || isprice == 1"
                src="../assets/image/botgray.png"
                alt=""
              />
              <img
                class="ml-5"
                v-if="isprice == 2"
                src="../assets/image/bot.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <Bookbox :list="boutiqueBooklist" :cols="5"></Bookbox>
        <!--分页-->
        <div class="pagination mt-50 pb-10 flex jc-center ai-center">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            layout="prev, pager, next, jumper"
            :total="total"
            :page-size="Number(10)"
            hide-on-single-page
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/common/breadcrumb";
import Bookbox from "../components/common/bookbox";
export default {
  name: "bookdownload",
  components: {
    Breadcrumb,
    Bookbox,
  },
  data() {
    return {
      bookname: "",
      auctor: "", //作者
      boutiqueBooklist: [],
      boutiqueBookid: 0, //新书推荐的id
      isdate: 0, //时间排序
      isprice: 0, //价格排序
      currentPage: 1,
      total: 0,
    };
  },
  mounted() {
    this.boutiquebook();
  },
  methods: {
    //监听书名
    watchname(e) {
      this.bookname = e.currentTarget.value;
    },
    //监听作者
    watchactor(e) {
      this.auctor = e.currentTarget.value;
    },
    search() {
      this.boutiquebook();
    },
    //获取精品期刊列表
    async boutiquebook() {
      var timeOrder = "";
      var priceOrder = "";
      if (this.isdate == 1) {
        timeOrder = "asc";
      } else if (this.isdate == 2) {
        timeOrder = "desc";
      } else if (this.isdate == 0) {
        timeOrder = "";
      }

      if (this.isprice == 1) {
        priceOrder = "asc";
      } else if (this.isprice == 2) {
        priceOrder = "desc";
      } else if (this.isprice == 0) {
        priceOrder = "";
      }
      var params = {
        type: this.CONSTANT.getDateByCode("requestbook_id").id,
        title: this.bookname,
        author: this.auctor,
        pageNum: this.currentPage,
        pageSize: "10",
        timeOrder: timeOrder,
        priceOrder: priceOrder,
      };
      var res = await this.$API.API_Ajax("图书列表", params);
      if (res.code == 200) {
        var list = res.data.list;
        list.map((item) => {
          item.time = this.$moment(new Date(item.createTime.time).getTime()).format(
            "YYYY.MM"
          );
        });
        this.boutiqueBooklist = list;
        if (this.boutiqueBooklist.length) {
          this.total = res.data.total;
        }
         //查询成功后回到顶部
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    //精品图书
    choseboutiquebook(index) {
      this.boutiqueBookid = index;
    },
    //时间排序
    chosedate() {
      if (this.isdate == 0) {
        this.isdate = 1;
      } else if (this.isdate == 1) {
        this.isdate = 2;
      } else if (this.isdate == 2) {
        this.isdate = 0;
      }
      this.boutiquebook();
    },
    choseprice() {
      if (this.isprice == 0) {
        this.isprice = 1;
      } else if (this.isprice == 1) {
        this.isprice = 2;
      } else if (this.isprice == 2) {
        this.isprice = 0;
      }
      this.boutiquebook();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.boutiquebook();
    },
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: auto;
  margin: auto;
  .booksearchCon {
    width: 65%;
    height: auto;
    margin: auto;
    .screencon {
      height: 60px;
      border-bottom: 1px solid #e4e4e4;
      input {
        width: 137px;
        height: 20px;
        border: 1px solid #dadada;
        padding: 5px;
      }
      .dline {
        width: 20px;
        height: 1px;
        background: #dadada;
      }
    }
    .resulttit {
      height: 70px;
      background: #f5f5f5;
      border: 1px solid #ededed;
    }
    .bookcon {
      width: 100%;
      .sort {
        width: 100%;
        height: 51px;
        margin: auto;
        margin-top: 20px;
        margin-bottom: 50px;
        border: 1px solid #ebe6e2;
        .con {
          width: 90%;
          height: 100%;
          margin: auto;
          .model {
            width: 134px;
            height: 35px;
            border: 1px solid #b2b2b2;
            img {
              width: 11px;
              height: 18px;
            }
          }
        }
      }
      .pagination {
        .btn {
          width: 60px;
          height: 24px;
        }
      }
    }
  }
}
</style>
